<template>
  <div class="device-conditions-wrapper">
    <DeviceCondition
      v-for="item in formattedDeviceConditionsArray"
      :key="item.label"
      :label="item.label"
      :dataCy="item.dataCy"
      :showDeviceConditionError="item.showDeviceConditionError"
      :showNotAvailableIcon="showNotAvailableIcon"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DeviceCondition from './DeviceCondition.vue'
import { activeLastDay } from '@/services/device-status'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'

interface DeviceConditionConfig {
  value: string
  label: string
  dataCy: string
}

interface FormattedDeviceCondition {
  label: string
  dataCy: string
  showDeviceConditionError: boolean
}

const DEVICE_CONDITIONS_CONFIGURATION: DeviceConditionConfig[] = [
  {
    value: 'FLOW',
    label: 'widget.currentReadings.flow',
    dataCy: 'flowDeviceCondition'
  },
  {
    value: 'LASER',
    label: 'widget.currentReadings.laser',
    dataCy: 'laserDeviceCondition'
  },
  {
    value: 'FILTER',
    label: 'widget.currentReadings.filter',
    dataCy: 'filterDeviceCondition'
  }
]

export default defineComponent({
  name: 'DeviceConditions',
  components: { DeviceCondition },
  props: {
    deviceId: String,
    lastTelemetryTimestamp: String
  },
  computed: {
    deviceConditionsErrors(): string[] | null {
      return this.$store.getters[
        `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_ERROR_STATE_BY_DEVICE_ID}`
      ](this.deviceId)
    },
    showNotAvailableIcon(): boolean {
      return !this.deviceConditionsErrors || !activeLastDay(this.lastTelemetryTimestamp) // or if we don't have recent activity
    },
    formattedDeviceConditionsArray(): FormattedDeviceCondition[] {
      return DEVICE_CONDITIONS_CONFIGURATION.map((configuration) => ({
        label: this.$t(configuration.label),
        dataCy: configuration.dataCy,
        showDeviceConditionError: this.showDeviceConditionError(configuration.value)
      }))
    }
  },
  methods: {
    showDeviceConditionError(deviceConditionValue: string): boolean {
      return !!(
        this.deviceConditionsErrors?.length &&
        this.deviceConditionsErrors.indexOf(deviceConditionValue) !== -1
      )
    }
  }
})
</script>

<style lang="scss" scoped>
.device-conditions-wrapper {
  display: flex;
  justify-content: center;
  font-size: 0.9rem;
  gap: 0 11%;
}
</style>
